import { ExitIcon, GreyUserIcon } from '../../../assets/images/UI-dashboard';
import { useAppDispatch, useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import {
  closeShareDialog,
  scenarioShare,
  updatedSelectedUserShareList,
} from '../../../features/scenarioLibrary/scenarioLibrarySlice';
import {
  StyledDialogHeader,
  StyledTitle,
  StyledExitButton,
  StyledUserContainer,
  StyledUserCard,
  StyledUserImageWrapper,
  StyledUserName,
} from '../ScenarioLibrary.Styled';
import { Button, Grid, Tooltip } from '@mui/material';
import { DropdDownGrid } from './commonStyles.Styled';
import { hideLoader, showLoader } from '../../../features/ui/loaderSlice';
import { formatName } from '../../../utils/helper';
import CustomDialogWrapper from '../../../components/UI/CustomDialogWrapper/CustomDialogWrapper';
import Swal from 'sweetalert2';

const ShareToUserPopup = () => {
  const dispatch = useAppDispatch();
  const dialogOpen = useAppSelector((state: RootState) => state.scenarioLibrary.isShareDialogOpen);
  const { usersShareList, selectedUsersShareList } = useAppSelector((state: RootState) => state.scenarioLibrary);
  const { scenarioName } = useAppSelector((state: RootState) => state.scenarioCreation);
  const handleCloseDialog = () => {
    dispatch(closeShareDialog());
  };

  const UserData = usersShareList?.names || [];

  const selectUserToShare = (name: string) => {
    const isSelected = selectedUsersShareList.includes(name);

    const updatedList = isSelected
      ? selectedUsersShareList.filter((user) => user !== name)
      : [...selectedUsersShareList, name];
    dispatch(updatedSelectedUserShareList(updatedList));
  };

  const handleShare = async () => {
    await handleCloseDialog();
    await dispatch(showLoader());
    const payload = {
      scenario_name: scenarioName,
      selected_users: selectedUsersShareList,
    };
    const res = await dispatch(scenarioShare(payload));
    await dispatch(hideLoader());
    if (res.payload.message === 'Scenario Shared successfully.') {
      Swal.fire({
        title: 'Success!',
        text: `Scenario "${scenarioName}" has been shared successfully.`,
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#E21824',
      });
    } else {
      Swal.fire({
        title: 'Error!',
        text: `${res.payload.message || 'Unknown error occured in API call'}`,
        icon: 'error',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#E21824',
      });
    }
  };

  return (
    <CustomDialogWrapper open={dialogOpen} onClose={handleCloseDialog} width="590px" height="470px">
      <Grid style={{ padding: '20px' }}>
        <StyledDialogHeader>
          <StyledTitle>Share</StyledTitle>
          <StyledExitButton onClick={handleCloseDialog}>
            <img style={{ opacity: '100%%' }} src={ExitIcon} alt="Exit" />
          </StyledExitButton>
        </StyledDialogHeader>
        <DropdDownGrid style={{ marginTop: '20px', height: '280px' }}>
          <StyledUserContainer>
            {UserData.map((ele: string) => (
              <StyledUserCard onClick={() => selectUserToShare(ele)} key={ele}>
                <StyledUserImageWrapper isSelected={selectedUsersShareList.includes(ele)}>
                  <img src={GreyUserIcon} alt="User" />
                </StyledUserImageWrapper>
                <Tooltip title={ele} arrow>
                  <StyledUserName>{formatName(ele)}</StyledUserName>
                </Tooltip>
              </StyledUserCard>
            ))}
          </StyledUserContainer>
        </DropdDownGrid>
      </Grid>
      <Grid
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          marginTop: '30px',
        }}
      >
        <Button
          onClick={() => handleShare()}
          sx={{
            color: 'white',
            width: '162px',
            height: '44px',
            marginBottom: '30px',
            fontSize: 14,
            '&:hover': {
              backgroundColor: '#E21824',
            },
          }}
        >
          Share
        </Button>
      </Grid>
    </CustomDialogWrapper>
  );
};

export default ShareToUserPopup;
